import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BlockButton from '../Utilities/BlockButton';
export default class CarouselControl extends PureComponent {
    render() {
        const { disabled, onClick, direction, large, hintText } = this.props;
        return (React.createElement(BlockButton, { className: "carousel-control", style: disabled ? { visibility: 'hidden' } : {}, onClick: !disabled ? onClick : undefined },
            React.createElement("i", { className: `fa${large ? ' fa-lg' : ''} fa-angle-${direction}`, "aria-hidden": "true" }),
            React.createElement("span", { className: "sr-only" }, hintText)));
    }
}
CarouselControl.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
    large: PropTypes.bool,
    hintText: PropTypes.string,
};
